/**
 * YDMobileReady - 移动端就绪协调器
 *
 * 仅移动端（<768px）激活。收集"重资源就绪"信号，
 * 全部到齐（或 8s 超时降级）后统一执行：建 pin → refresh(true) → release。
 *
 * API:
 *   YDMobileReady.need('seq-p1')      声明一个必须等待的信号（重复声明幂等）
 *   YDMobileReady.signal('seq-p1')    上报一个信号已就绪（重复上报幂等）
 *   YDMobileReady.onRelease(fn)       注册放行时回调（建 pin 等），可多次注册
 *   YDMobileReady.active               是否在移动端激活（boolean）
 *   YDMobileReady.lateRefresh()       降级放行后，迟到资源完成时补一次 refresh
 */
(function () {
  'use strict';

  var TIMEOUT_MS = 8000;

  // 与本页移动逻辑（intro / 序列帧）一致：仅 <768px 激活，避免平板区间与桌面 release 冲突
  var active = window.innerWidth < 768;
  var needed = Object.create(null);   // name -> true
  var ready = Object.create(null);    // name -> true
  var releaseCbs = [];
  var released = false;
  var timer = null;

  function allReady() {
    for (var name in needed) {
      if (!ready[name]) return false;
    }
    return true;
  }

  function doRelease(reason) {
    if (released) return;
    released = true;
    if (timer) { clearTimeout(timer); timer = null; }

    // 1) 放行回调（建 pin 等），任何异常不阻断后续
    for (var i = 0; i < releaseCbs.length; i++) {
      try { releaseCbs[i](); } catch (e) {}
    }

    // 2) 请求一次 refresh（safe 模式，rAF 合并）：刚建的 pin 会改变文档高度，下游 trigger 需重算。
    //    locked-vh 的追平/锁定交给 __sequenceScrollRelease 内部的 YDLockedVH.settle()，这里不再
    //    重复调用 YDLockedVH.refresh()，避免早期版本里「release 前后共 3–4 次全量 refresh」的风暴。
    try {
      if (window.ScrollTrigger && window.ScrollTrigger.refresh) window.ScrollTrigger.refresh(true);
    } catch (e) {}

    // 3) 解锁滚动（接管 early-lock release；其内部含 settle + safe refresh + scroll/Lenis 归零）
    var delegated = false;
    try {
      if (typeof window.__sequenceScrollRelease === 'function') {
        window.__sequenceScrollRelease();
        delegated = true;
      }
    } catch (e) {}
    if (!delegated) {
      try {
        if (window.YDLockedVH && typeof window.YDLockedVH.settle === 'function') window.YDLockedVH.settle();
      } catch (e) {}
    }

    try { console.log('[YDMobileReady] released:', reason); } catch (e) {}
  }

  function maybeRelease() {
    if (active && !released && allReady()) doRelease('all-signals');
  }

  var api = {
    active: active,
    need: function (name) {
      if (!active) return;
      needed[name] = true;
    },
    signal: function (name) {
      if (!active) return;
      ready[name] = true;
      maybeRelease();
    },
    onRelease: function (fn) {
      if (typeof fn !== 'function') return;
      if (released) { try { fn(); } catch (e) {} return; }
      releaseCbs.push(fn);
    },
    lateRefresh: function () {
      try {
        if (window.ScrollTrigger && window.ScrollTrigger.refresh) window.ScrollTrigger.refresh(true);
      } catch (e) {}
    }
  };

  window.YDMobileReady = api;

  // 桌面端：不接管任何流程，release 仍由原 intro 动画驱动
  if (!active) return;

  // 8s 超时降级放行（弱网宁可放行让用户能滚，不卡死）
  timer = setTimeout(function () { doRelease('timeout'); }, TIMEOUT_MS);
})();
